<template>
    <b-container fluid class="partners px-0">
        <div v-if="partner" class="header white d-flex align-items-center py-5">
            <div class="header-content w-100 text-center py-5">
                <div class="overlay"></div>

                <b-row class="content my-5 mx-0 d-flex justify-content-center">
                    <b-col cols="12" md="6" class="text-white text-left">
                        <div class="w-100 d-flex justify-content-center">
                            <b-img 
                                fluid
                                :src="require('@/assets/images/partners/' + partner.logo)"
                                :alt="partner.entreprise"
                                class="logo mb-5" 
                            /> 
                        </div>

                        <div class="d-flex justify-content-center mb-5">
                            <h3 class="upper bold display-5">{{ partner.entreprise }}: <span class="text-blue">{{ partner.subtitle }}</span></h3>
                        </div>

                        <p 
                            v-for="(p, index) in partner.description" 
                            :key="'paragraph-' + index"
                            class="text-left"
                        >{{ p }}</p>

                        <b-button 
                            block
                            class="btn-cta upper mt-5 py-3"
                            @click="sendMessage"
                        >
                            Contactez-nous pour en savoir plus
                        </b-button>

                        <b-button 
                            block
                            class="btn-cta upper mt-2 py-3"
                            :href="partner.url"
                            target="_blank"
                        >
                            Visitez le site web de {{ partner.entreprise }}
                        </b-button>
                    </b-col>    
                </b-row>   
            </div>
        </div>
    
        <Footer />  
    </b-container>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
    name: 'Partners',
    components: {
        Footer
    },
    data() {
        return {
            partners: [
                {
                    entreprise: `Square 9`,
                    link: `square-9`,
                    url: `https://www.square-9.com/`,
                    logo: `square-9.png`,
                    subtitle: `L'information en mouvement`,
                    description: [
                        `Il y a un monde d’informations dans vos documents.`,
                        `La suite de solutions logicielles de gestion de documents de Square 9 vous permet de 
                        capturer, d’extraire et de classer ces informations, en les transformant en informations 
                        exploitables vous permettant de travailler de manière plus intelligente, plus rapide et 
                        plus productive.`
                    ]
                },
                {
                    entreprise: `Konica Minolta Business Solutions`,
                    link: `konica-minolta`,
                    url: `https://www.konicaminolta.com/ca-fr`,
                    logo: `kmbs.png`,
                    subtitle: `Donner forme aux idées`,
                    description: [
                        `Depuis sa création en 1873, Konica Minolta s'est développé dans de nombreux domaines 
                        tels que le matériel de bureau, les systèmes optiques à usage industriel et les systèmes 
                        d'imagerie diagnostique. En enrichissant au maximum ses différentes technologies et 
                        innovations.`,
                        `Konica Minolta est présent dans la catégorie Monde et dans la catégorie Asie-Pacifique du 
                        Dow Jones Sustainability Index (DJSI) émis par le Dow Jones aux États-Unis et par l'organisme 
                        suisse RobecoSAM.`
                    ]
                },
                {
                    entreprise: `Panasonic Canada`,
                    link: `panasonic`,
                    logo: `panasonic.png`,
                    url: `https://na.panasonic.com/ca/fr`,
                    subtitle: `Un monde connecté nous transporte vers l’avant`,
                    description: [
                        `Bienvenue dans un monde connecté où les villes s’adaptent spontanément aux besoins des gens, 
                        où les véhicules se parlent entre eux pour éviter les accidents, et où les avions gardent 
                        les passagers en constante communication avec leurs vies au sol.`
                    ]
                },
                {
                    entreprise: `Fujitsu`,
                    link: `fujitsu`,
                    logo: `fujitsu.png`,
                    url: `https://www.fujitsu.com/ca/fr/`,
                    subtitle: `Focaliser sur la créativité, la connaissance et l'innovation`,
                    description: [
                        `Fujitsu est la première société japonaise de technologies de l'information et de la communication 
                        (TIC) offrant une gamme complète de produits, solutions et services à sa clientèle. Savoir plus 
                        sur les sociétés Fujitsu au Canada.`
                    ]
                }
            ]
        }
    },
    computed: {
        partner() {
            let selected = this.$route.params.partner 

            if (selected) {
                return this.findMatchingPartner( selected )
            }
                
            return false
        }
    },
    mounted() {
        let partners = document.getElementsByClassName('partners')[0]
        let navbar = document.getElementById('navbar')

        if(partners) partners.style.margin = navbar.offsetHeight + 'px 0 0 0'
    },
    methods: {
        findMatchingPartner(entreprise) {
            for (let a in this.partners) {
                let partner = this.partners[a]

                if ( partner.link === entreprise ) {
                    return partner
                }
            }

            this.$router.push('/notFound') 
            
            return false
        },
        titlize(string) {
            string = this.normalizeString( string.replace(/[\s\.,]/g, '-').toLowerCase() )

            return string
        },
        normalizeString(string) {
            return string.split('').map(function (letter) {
                let i = this.accents.indexOf(letter)
                return (i !== -1) ? this.out[i] : letter
                }.bind({
                accents: 'ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØÓòóôõöøóÈÉÊËĘèéêëęðÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑŃñńŠŚšśŸÿýŽŻŹžżź',
                out: 'AAAAAAAaaaaaaaBOOOOOOOOoooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNNnnSSssYyyZZZzzz'
                })
            ).join('')
        },
        sendMessage() {
            this.$emit('sendMessage')
        }
    }
}
</script>

<style scoped>
.header-content {
    background: url("../assets/images/partners-background.jpg") no-repeat center fixed;
    background-size: cover;
    position: relative;
    z-index: 10;
}

.header-content,
.header-content > .content {
    position: relative;
    z-index: 10;
}

.overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0,0,0,0.9);
}

.logo {
    width: 100%;
    max-width: 350px;
    filter: grayscale(10) brightness(8);
}
</style>

